export const EDIT_ASSIGNMENT_TEXT = {
	title: 'Record actual arrival/departure',
	description: 'Please enter the actual departure and arrival time for the station:',
	actualDeparture: 'Actual departure',
	actualArrival: 'Actual arrival',
	dateLabel: 'Date',
	timeLabel: 'Time',
	noteLabel: 'Note',
	cancelBtn: 'Cancel',
	confirmBtn: 'Confirm',
};
